module.exports = __webpack_public_path__ + "img/ez-slot-ic_register.e713254a.png";